export const Shop = {
    mainPage: 'Original Page',
    favs: 'Favorits',
    more: 'More',
    instagram: 'Instagram',
    shopTell: 'Shop Telephone',
    video: 'Video Channel',
    filters: 'Filters',
    byFilter: "By",
    curency: '$',
    search: 'Search',
    price: 'Price',
    name: 'Name',
    groups: 'Groups',
    subgroups: 'Subgroups',
    country: 'Country',
    brand: 'Brand',
    select: 'Select',
    update: 'Update',
    closeFilters: 'Close Filters',
    moreInfo: 'More Info',
    advanced: 'Advanced',
}